// extracted by mini-css-extract-plugin
export var button = "_63-7";
export var buttonRow = "_63-6";
export var fadeIn = "_63-1";
export var gradient = "_63-0";
export var panel = "_63-2";
export var panelIn = "_63-3";
export var subtitle = "_63-5";
export var title = "_63-4";